import React from "react";
import OverviewBusiness from "../components/OurBussiness/Overview.tsx";
import MetaComponent from "../components/CommonComponents/MetaComponent.tsx";
const Business = () => {
  return (
    <div>
      <MetaComponent
        title="Vocational Training Programs, Corporate Training Solutions & Career Oriented Training Centres | Aptech Limited"
        desc="Aptech Limited offers comprehensive vocational programs, customized corporate training solutions, and career-oriented training centres to build future-ready professionals."
        keywords="vocational training, skill training, enterprise business, institutional business, Aptech limited"
      />
      <OverviewBusiness />
    </div>
  );
};

export default Business;
